/* eslint-disable no-case-declarations */
import { SIDEBAR_TOGGLE } from '../../constants/ActionTypes';
import { getSidebarPositionFromStorage } from '../../helpers/sidebar';
import storage from '../../storage';

const initialSidebar = getSidebarPositionFromStorage();

const sidebar = (state = { sidebarPosition: initialSidebar }, action) => {
  switch (action.type) {
    case SIDEBAR_TOGGLE:
      const newSidebarPosition =
        state.sidebarPosition === 'expanded' ? 'closed' : 'expanded';

      storage.setItems({
        sidebarPosition: newSidebarPosition,
      });

      return { ...state, sidebarPosition: newSidebarPosition };
    default:
      return state;
  }
};

export default sidebar;
